import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Ciudad } from 'src/app/comun/models/ciudad';
import { Departamento } from 'src/app/comun/models/departamento';
import { ParametrosService } from 'src/app/services/parametros.service';
import { NeoCiudadClienteDTO } from '../../Model/neoCiudadClienteDTO';
import { NeoDepartamentosClienteDTO } from '../../Model/neoDepartamentosClienteDTO';
import { CiudadClienteService } from '../../Service/ciudad-cliente.service';
import { DepartamentosClienteService } from '../../Service/departamentos-cliente.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

declare var $: any;
@Component({
    selector: 'app-crear-ubicaciones-intermediario',
    templateUrl: './crear-ubicaciones-intermediario.component.html',
    styleUrls: ['./crear-ubicaciones-intermediario.component.scss'],
    standalone: false
})
export class CrearUbicacionesIntermediarioComponent implements OnInit {
  // IdNeoliente
  idNeoCliente: any;
  //Formulario lugares de atencion
  lugaresAtencionForm: UntypedFormGroup;
  //Lista de departamentos
  departamentos: Departamento[] = [];
  //Lista de ciudades
  ciudades: Ciudad[] = [];
  //booleano error
  isError: boolean = false;
  constructor(
    protected parametroService: ParametrosService,
    protected departamentosClienteService: DepartamentosClienteService,
    protected ciudadClienteService: CiudadClienteService,
    protected userIntermediarioService: UserService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private _sweetAlert: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.getIdNeoCliente();
    this.getDepartamentos('169');
    this.crearFormularioLugaresAtencion();
  }

  getIdNeoCliente(): any {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
  }

  getDepartamentos(idPais: string) {
    this.parametroService.getDepartamentos(idPais).subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  getCiudades(idDepartamento: string) {
    this.parametroService.getCiudades(idDepartamento).subscribe(
      (response) => {
        this.ciudades = response['data'];
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', false);
          $('#ciud').selectpicker('refresh');
        });
      }
    );
  }

  crearFormularioLugaresAtencion() {
    this.lugaresAtencionForm = this.formBuilder.group({
      idDepartamento: ['', Validators.required],
      idCliente_NeoCliente: [+this.idNeoCliente],
      aplicaTodasCiudades: [false],
      estado: ['HABILITADO'],
      ciudades: [''],
    });
  }

  isValidFieldLugaresIntermediarioForm(field: string) {
    return (
      (this.lugaresAtencionForm.get(field)?.dirty ||
        this.lugaresAtencionForm.get(field)?.touched) &&
      this.lugaresAtencionForm.get(field)?.invalid
    );
  }

  guardarLugares() {
    let auxTodasCiudades = this.lugaresAtencionForm.get('aplicaTodasCiudades').value
    let json: NeoDepartamentosClienteDTO = {
      idDepartamentoCliente: null,
      idDepartamento: +this.lugaresAtencionForm.get('idDepartamento').value,
      idCliente_NeoCliente: this.lugaresAtencionForm.get('idCliente_NeoCliente').value,
      aplicaTodasCiudades: auxTodasCiudades == true ? 1 : 0,
      estado: this.lugaresAtencionForm.get('estado').value,
      ciudades: this.guardarCiudades()
    }
    if (auxTodasCiudades) {
      json.ciudades = [];
    }
    this.departamentosClienteService.saveDepartamentosCliente(json).subscribe(
      (resp: any) => {
        if (resp.exitoso) {
          this.navegarMenuInicialUbicaciones();
          this._sweetAlert.successModal('Se ha creado el lugar de atención');
        } else {
          this._sweetAlert.errorModal('Se presento un error al momento de crear el lugar de atención');
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  actualizarCiudades() {
    if (this.lugaresAtencionForm.controls.aplicaTodasCiudades.value) {
      this.lugaresAtencionForm.controls.ciudades.setValidators(
        Validators.required
      );
    } else {
      this.lugaresAtencionForm.controls.ciudades.setValidators(null);
    }
  }

  obtenerIdCiudad(lista: NeoCiudadClienteDTO[]) {
    let idCiudades: any[] = []
    lista.forEach((element: any) => {
      idCiudades.push(element.idCiudad);
    });
    return idCiudades;
  }

  guardarCiudades() {
    let arregloCiudades: NeoCiudadClienteDTO[] = [];
    if (this.lugaresAtencionForm.controls.ciudades.value) {
      let valoresCiudades: any[] =
        this.lugaresAtencionForm.controls.ciudades.value;
      valoresCiudades.forEach((idC) => {
        const ciudadSegmento: NeoCiudadClienteDTO = {
          idCiudad: idC,
          idDepartamentoCliente_NeoDepartamentosCliente: null,
          idCiudadCliente: null,
          estado: 'HABILITADO',
        };
        arregloCiudades.push(ciudadSegmento);
      });
      return arregloCiudades;
    } else {
      return arregloCiudades = [];
    }
  }

  navegarMenuInicialUbicaciones() {
    this.router.navigate(['/intermediario/administracion/ubicaciones']);
  }
}